import React from "react";
import BrowserComponent from "../components/BrowserComponent";
import MobileComponent from "../components/MobileComponent";
import { deviceDetect, BrowserView, MobileView } from "react-device-detect";

function HomePage() {
  const [osN, setOsN] = React.useState("");

  React.useEffect(() => {
    let data = deviceDetect();
    //console.log(data);
    setOsN(data.os);
  }, [osN]);
  return (
    <div style={{ textAlign: "center" }}>
      <MobileView>
        <MobileComponent />
      </MobileView>

      <BrowserView>
        <BrowserComponent />
      </BrowserView>
    </div>
  );
}

export default HomePage;
